import React from "react";
import { Card, Tag, Empty, Row, Col } from "antd";
const darkCardStyle = {
  borderRadius: 12,
  background: "#1f1f1f",
  color: "#fff",
  border: "1px solid #333",
  marginBottom: 16,
};

const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const statusColors = {
  "SIAP KIRIM": { bg: "#1890ff", text: "#fff" }, // biru
  "BELUM BAYAR": { bg: "#ff4d4f", text: "#fff" }, // merah
  "BELUM ADA ALAMAT": { bg: "#722ed1", text: "#fff" }, // ungu
  "BELUM ADA ONGKIR": { bg: "#faad14", text: "#000" }, // kuning
};

const OrderCard = ({ order }) => {
  const statusStyle = statusColors[order.Status] || {
    bg: "#595959",
    text: "#fff",
  };

  return (
    <Card
      size="small"
      style={darkCardStyle}
      headStyle={{
        color: "#fff",
        borderBottom: "1px solid #333",
      }}
    >
      <div style={{ fontSize: "13px", color: "#aaa" }}>
        {formatDate(order.TglTransaksi)} | No: {order.No}
      </div>
      {/* Status */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 12,
        }}
      >
        <span style={{ color: "#fff", fontSize: 14 }}>
          No. Resi : {order.NoResi}
        </span>
      </div>

      {/* Detail utama */}

      <div style={{ marginBottom: 8 }}>
        <strong>Pesanan:</strong>
        <p style={{ margin: 0, color: "#ccc" }}>{order.Pesanan}</p>
      </div>
      <div style={{ marginBottom: 8 }}>
        <strong>Subtotal:</strong>{" "}
        <span style={{ color: "#52c41a", fontWeight: "bold" }}>
          Rp {order.SubTotal.toLocaleString("id-ID")}
        </span>
      </div>

      {/* Admin */}
      <div style={{ marginTop: 12 }}>
        <strong>Admin:</strong>{" "}
        <span style={{ color: "#40a9ff" }}>
          {order.NamaAdmin} ({order.NoAdmin})
        </span>
      </div>
    </Card>
  );
};

const OrderCardList = ({ orders }) => {
  if (!orders || orders.length === 0) {
    return (
      <Card style={darkCardStyle} bordered={false}>
        <Empty
          description={
            <span style={{ color: "#fff" }}>Tidak ada pesanan saat ini</span>
          }
        />
      </Card>
    );
  }

  return (
    <Row gutter={[16, 16]}>
      {orders.map((order, key) => (
        <Col xs={24} sm={20} md={16} key={key}>
          <OrderCard order={order} />
        </Col>
      ))}
    </Row>
  );
};

export default OrderCardList;
